import features from "features";

import Layout from "scenes/Layout/_Layout/_Layout";

const Main = (props: any): JSX.Element => {
  return (
    <Layout>
      <features.main.page {...props} />
    </Layout>
  );
};

export default Main;
